import {
  Component,
  Input
} from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { Filter } from 'src/app/learning-resources/learning-resources.component';

@Component({
    selector: 'app-expandable-chips',
    templateUrl: './expandable-chips.component.html',
    styleUrls: ['./expandable-chips.component.css'],
    standalone: false
})
export class ExpandableChipsComponent  {

  @Input() filter: Filter;
  @Input() drawer: MatDrawer;

  chips: any[] = [];

  totalCount = 0;
  maxChips = 4;
  showMoreFilters = false;

  get filterChips() {
    const returnItems: any[] = [];
    this.filter.CostItems.filter((r) => r.checked).forEach((value) => {
      returnItems.push(value);
    });

    this.filter.FormatItems.filter((r) => r.checked).forEach((value) => {
      returnItems.push(value);
    });

    this.filter.DomainItems.filter((r) => r.allComplete).forEach((value) => {
      if(value.allComplete){
        returnItems.push(value);
      }
    });

    this.filter.DomainItems.filter((r) => !r.allComplete).forEach((value) => {
      value.subtasks.filter((r) => r.checked).forEach((value) => {
        returnItems.push(value);
      });
    });

    return returnItems;
  }

  removeFilterItem(item: any) {
    if(typeof item === 'object' && Boolean(item.area)){
      item.checked = false;
    }else{
      item.allComplete = false;
      item.subtasks.forEach((value) => {
        value.checked = false;
      });
    }
  }

  clearAllFilters() {
    this.filter.CostItems.forEach((value) => {
      value.checked = false;
    });
    this.filter.FormatItems.forEach((value) => {
      value.checked = false;
    });
    this.filter.DomainItems.forEach((value) => {
      value.allComplete = false;
      value.subtasks.forEach((value) => {
        value.checked = false;
      });
    });
  }
}
